import { render, staticRenderFns } from "./ListArticleStats.vue?vue&type=template&id=8d2bf676&scoped=true"
import script from "./ListArticleStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleStats.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleStats.vue?vue&type=style&index=0&id=8d2bf676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2bf676",
  null
  
)

export default component.exports